import {mergeTo} from '#core/utils/config-utils.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {TableLeaguePage} from '../table-league-page.js';

import {competitionsTableFactory} from './competitions-table.factory.js';

import PALETTE_SCHEMA from './competitions-table.palette-schema.yaml';
import SCHEMA from './competitions-table.schema.yaml';

class CompetitionsTableFeature extends AbstractVisualFeature {
    get name() {
        return 'CompetitionsTable';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    get configSchema() {
        return SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return mergeTo(competitionsTableFactory(PALETTE), {
            EventTable: {
                dataRow: {
                    cell: {
                        showParticipantIcon: this.config.showTeamIcons,
                    },
                },
            },
        });
    }
}

new CompetitionsTableFeature(TableLeaguePage);
